import { parseTassetUid, Tasset, TassetSchema } from '../../Finance/models/Tasset'
import { getFinder, getInserter, getName } from 'src/util/src/zod'
import { withIdFromName } from '../../Generic/models/Name/withIdFromName'

export const allTassets: Tasset[] = []

export const addTasset = getInserter<Tasset>(getName(TassetSchema), TassetSchema, parseTassetUid, allTassets)

export const findTasset = getFinder(parseTassetUid, allTassets)

export const GHST = addTasset(withIdFromName({
  name: 'Aavegotchi',
  ticker: 'GHST',
}))
